import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function FilterValuesWithoutParentDialog({ handleConfirm, handleCancel }) {
  return (
    <Dialog
      title={"Warning: No Parent Dataset"}
      onClose={handleCancel}
    >
      <div style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        <p style={{ marginBottom: "15px", color: "var(--atlas-text-primary)" }}>
          The CSV file contains filter values, but this dataset does not have a parent dataset
          configured.
        </p>
        <p style={{ marginTop: "15px", color: Colors.warning, fontWeight: "bold" }}>
          Filter values will not be imported.
        </p>
        <p style={{ marginTop: "15px", color: "var(--atlas-text-primary)" }}>
          Do you want to continue with the import?
        </p>
      </div>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnFilterValuesWithoutParentCancel`}
          style={{ backgroundColor: Colors.secondary }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          className="k-button"
          name={`btnFilterValuesWithoutParentConfirm`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleConfirm}
        >
          Continue
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default FilterValuesWithoutParentDialog;

